export const getFormattedAdminTeamFilter = callerIds => {
  let adminTeam = '';

  for (var i = 0; i < callerIds.length; i++) {
    const withSemicolon = callerIds.length - 1 !== i;
    const { TenantID, CallerID } = callerIds[i];
    const value = `${TenantID}:${CallerID}`;
    adminTeam += withSemicolon ? `${value};` : value;
  }

  return adminTeam ? adminTeam : null;
};
